import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
// tslint:disable-next-line:no-submodule-imports
import { lodashUtil } from '@antv/l7-utils';
var merge = lodashUtil.merge;
export var Event = /*#__PURE__*/_createClass(function Event(type) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _classCallCheck(this, Event);
  merge(this, data);
  this.type = type;
});